import React, { useEffect, useState } from "react";
import { Select, Table, Button, IconDownload } from "@veneer/core";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import moment from "moment";
import { numberFormatCommaTwoFraction } from "./../../../common/js/utils/numberFormat";
import XLSX from "xlsx";
import { Trans } from "react-i18next";
import { withTranslation } from "react-i18next";
import { authenticationService } from "../../../services/context/AuthService";


const BalanceReport = (props) => {
  const configBalanceReport = [
    {
      id: "lastPublicationDateFormated",
      label: <Trans i18nKey="balancereport.lastpub" />,
    },
    {
      id: "customerName",
      label: <Trans i18nKey="channel" />,
    },
    {
      id: "endUserNameLink",
      label: <Trans i18nKey="specialcondition.enduser" />,
    },
    {
      id: "lastPublicationRedeemedFormatted",
      label: <Trans i18nKey="balancereport.lastpubred" />,
    },
    {
      id: "nextAvailableFormatted",
      label: <Trans i18nKey="balancereport.nextredeemav" />,
    },
    {
      id: "balanceFormatted",
      label: <Trans i18nKey="balancereport.compclient" />,
    },
    {
      id: "debitSincePublicationFormatted",
      label: <Trans i18nKey="balancereport.debitsince" />,
    },
    {
      id: "creditSincePublicationFormatted",
      label: <Trans i18nKey="balancereport.creditsince" />,
    },
    {
      id: "balanceBeforePublicationFormatted",
      label: <Trans i18nKey="balancereport.balancepubdate" />,
    },
    {
      id: "series",
      label: "Series",
    },
  ];

  const configBalanceChannelReport = [
    {
      id: "lastPublicationDateFormated",
      label: <Trans i18nKey="balancereport.lastpub" />,
    },
    {
      id: "customerName",
      label: <Trans i18nKey="channel" />,
    },
    {
      id: "endUserNameLink",
      label: <Trans i18nKey="specialcondition.enduser" />,
    },
    {
      id: "lastPublicationRedeemedFormatted",
      label: <Trans i18nKey="balancereport.lastpubred" />,
    },
    {
      id: "nextAvailableFormatted",
      label: <Trans i18nKey="balancereport.nextredeemav" />,
    },
    {
      id: "balanceFormatted",
      label: <Trans i18nKey="balancereport.compclient" />,
    },
    {
      id: "debitSincePublicationFormatted",
      label: <Trans i18nKey="balancereport.debitsince" />,
    },
    {
      id: "creditSincePublicationFormatted",
      label: <Trans i18nKey="balancereport.creditsinceTP" />,
    },
    {
      id: "balanceBeforePublicationFormatted",
      label: <Trans i18nKey="balancereport.balancepubdateTP" />,
    },
    {
      id: "series",
      label: "Series",
    },
  ];

  const connectApi = new ConnectAPI();
  const [order, setOrder] = useState(configBalanceReport.map((c) => c.id));
  const [channelOrder, setChannelOrder] = useState(
    configBalanceChannelReport.map((c) => c.id)
  );
  const [orderBy, setOrderBy] = useState("customerName");
  const [orderType, setOrderType] = useState("ascending");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [channelOrderBy, setChannelOrderBy] = useState("customerName");
  const [channelOrderType, setChannelOrderType] = useState("ascending");
  const [tableChannelData, setTableChannelData] = useState([]);
  const [currentChannelPage, setCurrentChannelPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const pageSize = 50;
  const [customerName, setCustomerName] = useState("");
  const [channelSelected, setChannelSelected] = useState("whole");
  const [channelSelectDisabled, setChannelSelectDisabled] = useState(false);
  const [channelsView, setChannelsView] = useState([]);
  const info = localStorage.getItem("currentUser");
  var a = JSON.parse(info);
  var idrole = a.idRole;

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = tableData.map(item => {
        return {
          lastPublicationDate: item.lastPublicationDateFormated,
          channel: item.customerName,
          endUser: item.endUserName,
          lastPublicationRedeemed: item.lastPublicationRedeemedFormatted,
          nextRedeemAvailableFromPublicationOf: item.nextAvailableFormatted,
          compensationClient: item.balanceFormatted,
          debitSincePublication: item.debitSincePublicationFormatted,
          creditSincePublication: item.creditSincePublicationFormatted,
          balanceInThePublicationDate: item.balanceBeforePublicationFormatted,
          series: item.series
        };
      });

      const dataXlsx = excelData;
      const ws = XLSX.utils.json_to_sheet(dataXlsx);
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format("YYYYMMDDHHmm");

      const filename = "Balance Report -" + date + ".xlsx";
      const ws_name = "End Users";

      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      if(idrole < 11 && tableChannelData.length > 0){
        const channelExcelData = tableChannelData.map(item => {
          return {
            lastPublicationDate: item.lastPublicationDateFormated,
            channel: item.customerName,
            endUser: item.endUserName,
            lastPublicationRedeemed: item.lastPublicationRedeemedFormatted,
            nextRedeemAvailableFromPublicationOf: item.nextAvailableFormatted,
            compensationClient: item.balanceFormatted,
            debitSincePublication: item.debitSincePublicationFormatted,
            creditSincePublication: item.creditSincePublicationFormatted,
            balanceInThePublicationDate: item.balanceBeforePublicationFormatted,
            series: item.series
          };
        });

        const wsB = XLSX.utils.json_to_sheet(channelExcelData);
        const wsBName = 'Channels';

        XLSX.utils.book_append_sheet(wb, wsB, wsBName);

      }
      
      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
    });
    if (validate==false){
        const { history } = props;
        history.push({
            pathname: '/' 
        });
    }
    //end validate
    const fetchData = () => {
      connectApi.get("api/Channels", "", channelsLoad).catch((error) => {
        console.log(error);
        if(error.response.status==510){
          authenticationService.logout();
        }else{
          Swal.fire(
            "Error " + error?.response?.status,
            error?.response?.data,
            "error"
          );
        }
        
      });
    };
    const channelsLoad = (status, data) => {
      const items = data.map((item) => {
        return {
          value: item.idCustomer,
          label: item.name,
        };
      });
      if (items.length == 1) {
        setChannelSelected(items[0].value);
        setChannelSelectDisabled(true);
      }
      getTablesData(items);
    };
    fetchData();
  }, []);

  function getTablesData(channels) {
    let endUserGroup2Data = [];
    let endUsersData = [];
    let channelsData = [];

    const fetchData = async () => {
      setIsLoading(true);
      connectApi
        .get("api/Channels/compensation/balanceReport", "", dataResponseLoad)
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            "Error " + error?.response?.status,
            error?.response?.data,
            "error"
          );
        });
    };

    const fetchDataCR = async () => {
      setIsLoading(true);
      connectApi
        .get(
          "api/Channels/compensation/customerBalanceReport",
          "",
          dataResponseChannel
        )
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            "Error " + error?.response?.status,
            error?.response?.data,
            "error"
          );
        });
    };

    const dataResponseChannel = (status, data) => {
      channelsData = data;
      data.map((item, key) => {
        item.lastPublicationDateFormated = moment(
          item.lastPublicationDate
        ).format("MMM/YYYY");
        item.lastPublicationRedeemedFormatted = moment(
          item.lastPublicationRedeemed
        ).format("MMM/YYYY");
        item.nextAvailableFormatted = moment(item.nextAvailable).format(
          "MMM/YYYY"
        );
        item.balanceFormatted = numberFormatCommaTwoFraction(
          item.balance
        );
        item.debitSincePublicationFormatted = numberFormatCommaTwoFraction(
          item.debitSincePublication
        );
        item.creditSincePublicationFormatted = numberFormatCommaTwoFraction(
          item.creditSincePublication
        );
        item.balanceBeforePublicationFormatted = numberFormatCommaTwoFraction(
          item.balanceBeforePublication
        );
        item.series = item.series == 0 ? "" : item.series;
      });

      if (endUserGroup2Data.length > 0) {
        data = [...data, ...endUserGroup2Data];
      }

      const filteredChannels = channels.filter(
        (channel) =>
          endUsersData.findIndex((x) => x.customerName == channel.label) > -1 ||
          channelsData.findIndex((x) => x.customerName == channel.label) > -1
      );

      setChannelsView(filteredChannels);
      setTableChannelData(data);
      setIsLoading(false);
    };

    const dataResponseLoad = (status, data) => {
      endUsersData = data;

      data.map((item, key) => {
        item.lastPublicationDateFormated = moment(
          item.lastPublicationDate
        ).format("MMM/YYYY");
        item.lastPublicationRedeemedFormatted = moment(
          item.lastPublicationRedeemed
        ).format("MMM/YYYY");
        item.nextAvailableFormatted = moment(item.nextAvailable).format(
          "MMM/YYYY"
        );
        item.balanceFormatted = numberFormatCommaTwoFraction(
          item.balance
        );
        item.debitSincePublicationFormatted = numberFormatCommaTwoFraction(
          item.debitSincePublication
        );
        item.creditSincePublicationFormatted = numberFormatCommaTwoFraction(
          item.creditSincePublication
        );
        item.balanceBeforePublicationFormatted = numberFormatCommaTwoFraction(
          item.balanceBeforePublication
        );
      });

      setTableData(
        data === undefined ? [] : data.filter((x) => x.endUserGroup != 2)
      );

      endUserGroup2Data = data.filter((x) => x.endUserGroup == 2);

      if (endUserGroup2Data.length > 0) {
        endUserGroup2Data = endUserGroup2Data.map((item) => {
          // item.idEndUser = item.endUserName;
          item.idCustomer = item.customerName;
          return item;
        });
      }

      fetchDataCR();
    };

    fetchData();
  }

  const handlePageChange = (page) => setCurrentPage(page);

  const handleChannelPageChange = (page) => setCurrentChannelPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };

  const handleOnColumnChannelReorder = (newOrder) => {
    setChannelOrder(newOrder);
  };

  const filteredData = filterSort(
    tableData,
    { customerName },
    orderBy,
    orderType
  );

  const filteredChannelData = filterSort(
    tableChannelData,
    { customerName },
    channelOrderBy,
    channelOrderType
  );

  const handleSelectReport = (item) => (event) => {
    event.preventDefault();
    const { history } = props;
    history.push({
      pathname: '/cpp/report/' + item.idEndUser,
      data: item,
    });
  };

  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter =
        typeof filterValue === "object" ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === "descending"
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === "object"
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    //const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === "object"
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();
    //const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

    if (orderBy.includes("Formatted")) {
      const orderByFormatted = orderBy.replace("Formatted", "");
      aSort = a[orderByFormatted];
      bSort = b[orderByFormatted];
    }

    // if( typeof a[orderBy] == "number"){
    //   aSort = a[orderBy];
    //   bSort = b[orderBy];
    // }

    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  ).map(x => {
    x.endUserNameLink = (
      <a href={"/cpp/report/" + x.idEndUser}>
        {x.endUserName}
      </a>
    );
    return x;
  });

  let pagedChannelData = filteredChannelData.slice(
    (currentChannelPage - 1) * pageSize,
    (currentChannelPage - 1) * pageSize + pageSize
  ).map(x => {
    x.endUserNameLink = (
      <a href={"/cpp/report/" + x.idEndUser}>
        {x.endUserName}
      </a>
    );
    return x;
  });

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
  };

  const handleChannelSort = (_, { id, type }) => {
    setChannelOrderBy(id);
    setChannelOrderType(type);
  };

  const RenderChannelsList = () => {
    const handleSelectChange = (name) => (event) => {
      setChannelSelected(event.value);
      setCustomerName(event.label);
    };

    return (
      <div
        style={{
          width: "350px",
          padding: "0.5% 2% ",
        }}
      >
        <Select
          name="channel"
          onChange={handleSelectChange()}
          onClear={handleClearChannel()}
          options={channelsView}
          placeholder={<Trans i18nKey="channels" />}
          showSearch={false}
          value={[channelSelected]}
          disabled={channelSelectDisabled}
        />
      </div>
    );
  };

  const handleClearChannel = (name) => (event) => {
    setChannelSelected("whole");
    setCustomerName("");
  };

  return (
    <div>
      <br />
      <div className="row" style={{ textAlign: "left", padding: "0.5%" }}>
        {RenderChannelsList()}
      </div>

      <div>
        <br />
        <div
          style={{
            backgroundColor: "#f2f2f2",
            padding: "0.5%",
          }}
        >
          <Table
            showFilters
            columnReorder
            columns={[
              {
                id: "lastPublicationDateFormated",
                label: <Trans i18nKey="balancereport.lastpub" />,
              },
              {
                id: "customerName",
                label: <Trans i18nKey="channel" />,
              },
              {
                id: "endUserNameLink",
                label: <Trans i18nKey="specialcondition.enduser" />,
              },
              {
                id: "lastPublicationRedeemedFormatted",
                label: <Trans i18nKey="balancereport.lastpubred" />,
              },
              {
                id: "nextAvailableFormatted",
                label: <Trans i18nKey="balancereport.nextredeemav" />,
              },
              {
                id: "balanceFormatted",
                label: <Trans i18nKey="balancereport.compclient" />,
              },
              {
                id: "debitSincePublicationFormatted",
                label: <Trans i18nKey="balancereport.debitsince" />,
              },
              {
                id: "creditSincePublicationFormatted",
                label: <Trans i18nKey="balancereport.creditsince" />,
              },
              {
                id: "balanceBeforePublicationFormatted",
                label: <Trans i18nKey="balancereport.balancepubdate" />,
              },
              {
                id: "series",
                label: "Series",
              },
            ]}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSort={handleSort}
            loading={isLoading}
            preferences={{
              defaultOrder: configBalanceReport.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
          ></Table>
          <br />

          {idrole < 11 && tableChannelData.length > 0 ? (
            <Table
              showFilters
              columnReorder
              columns={[
                {
                  id: "lastPublicationDateFormated",
                  label: <Trans i18nKey="balancereport.lastpub" />,
                },
                {
                  id: "customerName",
                  label: <Trans i18nKey="channel" />,
                },
                {
                  id: "endUserNameLink",
                  label: <Trans i18nKey="specialcondition.enduser" />,
                },
                {
                  id: "lastPublicationRedeemedFormatted",
                  label: <Trans i18nKey="balancereport.lastpubred" />,
                },
                {
                  id: "nextAvailableFormatted",
                  label: <Trans i18nKey="balancereport.nextredeemav" />,
                },
                {
                  id: "balanceFormatted",
                  label: <Trans i18nKey="balancereport.compclient" />,
                },
                {
                  id: "debitSincePublicationFormatted",
                  label: <Trans i18nKey="balancereport.debitsince" />,
                },
                {
                  id: "creditSincePublicationFormatted",
                  label: <Trans i18nKey="balancereport.creditsinceTP" />,
                },
                {
                  id: "balanceBeforePublicationFormatted",
                  label: <Trans i18nKey="balancereport.balancepubdateTP" />,
                },
                {
                  id: "series",
                  label: "Series",
                },
              ]}
              data={pagedChannelData}
              onColumnReorder={handleOnColumnChannelReorder}
              onSort={handleChannelSort}
              loading={isLoading}
              preferences={{
                defaultOrder: configBalanceChannelReport.map((c) => c.id),
                order: channelOrder,
                sortBy: {
                  id: channelOrderBy,
                  type: channelOrderType,
                },
              }}
              pagination={{
                currentpage: currentChannelPage,
                onPageChange: handleChannelPageChange,
                pageSize,
                totalItems: filteredChannelData.length,
              }}
            ></Table>
          ) : (
            ""
          )}
        </div>
      </div>
      <br />
      <div style={{ textAlign: "left" }}>
        <Button
          leadingIcon={<IconDownload />}
          onClick={() => {
            exportData();
          }}
          disabled={filteredData.length === 0}
          loading={loadingExport}
          title="Download Data"
        >
          <Trans i18nKey="download" />
        </Button>
      </div>
    </div>
  );
};

export default withTranslation()(BalanceReport);
